import { __assign, __read, __spread } from "tslib";
import localeData from '@wix/locale-dataset-javascript';
import { filterUnsupportedCountries } from './unsupportedCountriesFilter';
import { removeUnsupportedSubdivisions, isUnsupportedSubdivision } from './unsupportedSubdivisionsRemover';
var _experiments = null;
var reverseNameOrderCountries = getAllCountries().reduce(function (acc, country) {
    if (country.reverseNameOrder) {
        return __spread(acc, [country.key, country.shortKey]);
    }
    return acc;
}, []);
export function setExperiments(experiments) {
    _experiments = experiments;
}
export function getAllCountries(opts) {
    var countries = localeData.getAllCountries(opts);
    var supportCountries = filterUnsupportedCountries(countries);
    removeUnsupportedSubdivisions(supportCountries, _experiments);
    return supportCountries;
}
export function getCountryByKey(countryKey, opts) {
    var country = localeData.getCountryByKey(countryKey, opts);
    if (!country) {
        return null;
    }
    removeUnsupportedSubdivisions([country], _experiments);
    return country;
}
export function getCountryByShortKey(countryShortKey, opts) {
    var country = localeData.getCountryByShortKey(countryShortKey, opts);
    if (!country) {
        return null;
    }
    removeUnsupportedSubdivisions([country], _experiments);
    return country;
}
export function getStateByKey(countryKey, stateKey) {
    var subdivision = localeData.getStateByKey(countryKey, stateKey);
    if (!subdivision) {
        return null;
    }
    if (isUnsupportedSubdivision(countryKey, stateKey, _experiments)) {
        return null;
    }
    return subdivision;
}
export function getAllCurrencies() {
    return localeData.getAllCurrencies();
}
export function getCurrencyByKey(currencyKey) {
    return localeData.getCurrencyByKey(currencyKey);
}
export function getAllLocales() {
    return localeData.getAllLocales();
}
export function getLocaleByKey(localeKey) {
    return localeData.getLocaleByKey(localeKey);
}
export function getAllTimezones() {
    return localeData.getAllTimezones();
}
export function getTimezoneByKey(timezoneKey) {
    return localeData.getTimezoneByKey(timezoneKey);
}
export function getFormattedAddress(addressParts, formatCountryKey) {
    return localeData.getFormattedAddress(addressParts, formatCountryKey);
}
export function getDemoAddresses() {
    return localeData.getDemoAddresses();
}
export function getDemoAddressByKey(currencyKey) {
    return localeData.getDemoAddressByKey(currencyKey);
}
export function getAllSupportedLanguages() {
    return localeData.getAllSupportedLanguages();
}
export function isReverseNameOrder(countryKey) {
    return reverseNameOrderCountries.includes(countryKey);
}
export function getDefaultAddressDisplayNames() {
    return localeData.getDefaultAddressDisplayNames();
}
export default __assign(__assign({}, localeData), { getAllCountries: getAllCountries,
    getCountryByKey: getCountryByKey,
    getCountryByShortKey: getCountryByShortKey,
    getStateByKey: getStateByKey,
    getAllCurrencies: getAllCurrencies,
    getCurrencyByKey: getCurrencyByKey,
    getAllLocales: getAllLocales,
    getLocaleByKey: getLocaleByKey,
    getAllTimezones: getAllTimezones,
    getTimezoneByKey: getTimezoneByKey,
    getFormattedAddress: getFormattedAddress,
    getDemoAddresses: getDemoAddresses,
    getDemoAddressByKey: getDemoAddressByKey,
    getAllSupportedLanguages: getAllSupportedLanguages,
    getDefaultAddressDisplayNames: getDefaultAddressDisplayNames,
    setExperiments: setExperiments });
//# sourceMappingURL=index.js.map